import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { DeferredParser } from '../../DeferredParser';
import { Fetcher } from '../../Fetcher';

import { userInfoEndpoint } from './endpoints';
import { UserInfoType } from './types';

export interface FetchUserInfoOptions {
  totalBalance: boolean;
}

export interface FetchUserInfoParams {
  JSESSIONID: string;
  force?: boolean;
  baseUrl: string;
}

export class UserInfoFetcherBase extends DeferredParser<FetchUserInfoParams, UserInfoType> {
  constructor() {
    super(({ JSESSIONID, force, baseUrl }) =>
      Fetcher.fetch(`${baseUrl}${userInfoEndpoint.url}`, {
        force,
        params: {
          JSESSIONID,
        },
        format: 'json',
      })
    );
  }

  setOptions(options: FetchUserInfoOptions): void {
    this.parseWith((data) => {
      updateApiMask(ApiMask.Balance);
      return userInfoEndpoint.parser(data, options);
    });
  }
}

export const UserInfoFetcher = new UserInfoFetcherBase();
